import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Accordion, Card, Spinner } from 'react-bootstrap';
import { FaPlus, FaMinus, FaTrash, FaEdit, FaWhatsapp } from 'react-icons/fa';
import Breadcrumbs from './../../../CommonElements/Breadcrumbs/index';
import { addFaq, deleteFaq, getFaqbySort, updateFaq } from '../../../api-handle/supportApi';

const primaryColor = '#33bdbf';

const SupportPage = () => {
    const [faqs, setFaqs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalShow, setModalShow] = useState(false);
    const [currentFaq, setCurrentFaq] = useState(null);
    const [formState, setFormState] = useState({ question: '', answer: '', sort: '' });
    const [activeKey, setActiveKey] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [faqToDelete, setFaqToDelete] = useState(null);

    useEffect(() => {
        fetchFaqs();
    }, []);

    const fetchFaqs = async () => {
        try {
            setLoading(true);
            const response = await getFaqbySort(); // assumes sorted data
            setFaqs(response?.faqs || []);
        } catch (err) {
            console.error('Failed to fetch FAQs:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async () => {
        try {
            const payload = {
                question: formState.question,
                answer: formState.answer,
                sort: Number(formState.sort) || 0,
            };

            if (currentFaq) {
                await updateFaq({ ...payload, faqId: currentFaq._id });
            } else {
                await addFaq(payload);
            }

            await fetchFaqs();
            setModalShow(false);
            setFormState({ question: '', answer: '', sort: '' });
            setCurrentFaq(null);
        } catch (err) {
            console.error('Error submitting FAQ:', err);
        }
    };

    const confirmDelete = async () => {
        if (!faqToDelete) return;
        try {
            await deleteFaq(faqToDelete._id);
            await fetchFaqs();
        } catch (err) {
            console.error('Error deleting FAQ:', err);
        } finally {
            setShowDeleteModal(false);
            setFaqToDelete(null);
        }
    };

    const openEdit = (faq) => {
        setCurrentFaq(faq);
        setFormState({
            question: faq.question,
            answer: faq.answer,
            sort: faq.sort?.toString() || '',
        });
        setModalShow(true);
    };

    const openAdd = () => {
        setCurrentFaq(null);
        setFormState({ question: '', answer: '', sort: '' });
        setModalShow(true);
    };

    const [sortError, setSortError] = useState('');


    return (
        <div style={{ fontFamily: 'Segoe UI' }}>
            <Breadcrumbs mainTitle="FAQ's Management" parent="FAQ" title="FAQ's" />

            <div style={{ marginTop: '20px' }}>
                <Button style={{ backgroundColor: primaryColor, border: 'none' }} onClick={openAdd}>
                    + Add FAQ
                </Button>

                {loading ? (
                    <div style={{ marginTop: '30px', textAlign: 'center' }}>
                        <Spinner animation="border" variant="info" />
                    </div>
                ) : (
                    <Accordion activeKey={activeKey} style={{ marginTop: '20px' }}>
                        {faqs.map((faq, index) => (
                            <Card key={faq._id} style={{ marginBottom: '10px', borderRadius: '8px' }}>
                                <Card.Header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#f8f9fa' }}>
                                    <div
                                        style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', fontWeight: '500' }}
                                        onClick={() => setActiveKey(activeKey === index.toString() ? null : index.toString())}
                                    >
                                        {activeKey === index.toString() ? <FaMinus color={primaryColor} /> : <FaPlus color={primaryColor} />}
                                        <span style={{ marginLeft: '10px' }}>{faq.question}</span>
                                    </div>
                                    <div>
                                        <FaEdit
                                            onClick={() => openEdit(faq)}
                                            style={{ cursor: 'pointer', marginRight: '15px', color: primaryColor }}
                                        />
                                        <FaTrash
                                            onClick={() => {
                                                setFaqToDelete(faq);
                                                setShowDeleteModal(true);
                                            }}
                                            style={{ cursor: 'pointer', color: 'red' }}
                                        />
                                    </div>
                                </Card.Header>
                                <Accordion.Collapse eventKey={index.toString()}>
                                    <Card.Body>{faq.answer}</Card.Body>
                                </Accordion.Collapse>
                            </Card>
                        ))}
                    </Accordion>
                )}
            </div>

            {/* Add/Edit Modal */}
            <Modal show={modalShow} onHide={() => setModalShow(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{currentFaq ? 'Edit FAQ' : 'Add FAQ'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="faqQuestion">
                            <Form.Label>Question</Form.Label>
                            <Form.Control
                                type="text"
                                value={formState.question}
                                onChange={(e) => setFormState({ ...formState, question: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="faqAnswer" className="mt-3">
                            <Form.Label>Answer</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                value={formState.answer}
                                onChange={(e) => setFormState({ ...formState, answer: e.target.value })}
                            />
                        </Form.Group>
                        <Form.Group controlId="faqSort" className="mt-3">
                            <Form.Label>Sort (Optional)</Form.Label>
                            <Form.Control
                                type="number"
                                value={formState.sort}
                                isInvalid={!!sortError}
                                onChange={(e) => {
                                    const value = e.target.value;

                                    // Allow only digits and max 4 characters
                                    if (value.length > 4) return;

                                    // Prevent entering values over 9999
                                    if (Number(value) > 9999) {
                                        setSortError('Sort value cannot exceed 9999.');
                                    } else {
                                        setSortError('');
                                        setFormState({ ...formState, sort: value });
                                    }
                                }}
                            />
                            {sortError && (
                                <Form.Text className="text-danger">
                                    {sortError}
                                </Form.Text>
                            )}
                        </Form.Group>

                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setModalShow(false)}>
                        Cancel
                    </Button>
                    <Button style={{ backgroundColor: primaryColor, border: 'none' }} onClick={handleSubmit}>
                        {currentFaq ? 'Update' : 'Add'}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Delete Confirmation Modal */}
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete this FAQ?
                    <br />
                    <strong>{faqToDelete?.question}</strong>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={confirmDelete}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* WhatsApp Support Floating Button */}
            <a
                href="https://wa.me/your_number_here"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    position: 'fixed',
                    bottom: '25px',
                    right: '25px',
                    backgroundColor: '#25D366',
                    color: '#fff',
                    borderRadius: '50%',
                    width: '60px',
                    height: '60px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    boxShadow: '0 0 15px rgba(37, 211, 102, 0.8)',
                    zIndex: 9999,
                    animation: 'pulse 2s infinite'
                }}
            >
                <FaWhatsapp size={28} />
            </a>

            <style>{`
                @keyframes pulse {
                    0% {
                        box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.6);
                    }
                    70% {
                        box-shadow: 0 0 0 10px rgba(37, 211, 102, 0);
                    }
                    100% {
                        box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
                    }
                }
            `}</style>
        </div>
    );
};

export default SupportPage;
